import { useMutation } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

// common
import { handleException } from 'modules/account/detail/helpers/utils';
import useGeneralHook from 'common/hook/useGeneralHook';
import useService from 'common/hook/useService';
import { AppState } from '@redux/store';
import { setUserInfo } from '@redux/authReducer';

interface MutatingProps {
  newUserInfo: {
    title: string;
    name: string;
    email: string;
    miscData: {
      JobPosition: string;
      Phone: string;
      Address: string;
      IdDoc: string;
      IdDocIssuedAt: string;
      IdDocIssuedBy: string;
      Dob: string;
      Gender: string;
    };
  };
}

const useUpdateInfoLoggedInUser = () => {
  const { formatMessage } = useIntl();
  const { enqueueSnackbar, dispatch } = useGeneralHook();
  const currentUserInStore = useSelector((s: AppState) => s.auth.userInfo);
  const service = useService();

  const updateUserEmailInStore = (email: string) => {
    if (!currentUserInStore || !currentUserInStore.userAuthen) return;

    dispatch(
      setUserInfo({
        ...currentUserInStore,
        userAuthen: {
          ...currentUserInStore.userAuthen,
          email: email,
        },
      })
    );
  };

  return useMutation({
    mutationFn: async ({ newUserInfo }: MutatingProps) => {
      try {
        if (!service) return null;

        const result = await service.UserController_editData(newUserInfo);
        if (result.id) {
          enqueueSnackbar({
            message: formatMessage({ id: 'updateSuccess' }),
            variant: 'success',
          });
        }
        updateUserEmailInStore(newUserInfo.email);
      } catch (error) {
        handleException(error, { notifyUser: false });
        throw error;
      }
    },
  }).mutateAsync;
};

export default useUpdateInfoLoggedInUser;
